<template>
  <v-chart
    :loading="isLoading === true || data === undefined"
    class="chart"
    :option="option"
    autoresize
  />
</template>

<script lang="ts" setup>
import moment from 'moment'
import { provide, ref, defineProps, watch } from 'vue'
import { DASChart } from '@/server/MakeSenseApp-backend'

import { use } from 'echarts/core'
import VChart, { THEME_KEY } from 'vue-echarts'
import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  MarkAreaComponent,
  DataZoomComponent
} from 'echarts/components'
import { HeatmapChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'

use([
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  HeatmapChart,
  CanvasRenderer,
  MarkAreaComponent,
  UniversalTransition,
  DataZoomComponent
])

provide(THEME_KEY, 'light')

var props = defineProps({
  data: DASChart,
  isLoading: Boolean
})

let option = ref<any>()

watch(
  () => props.data,
  () => {
    option.value = {
      tooltip: {
        position: 'top',
        formatter: function (params: any) {
          return `${params.value[2]} dB`
        }
      },
      xAxis: {
        type: 'category',
        data: (props.data ? props.data?.xData : [])?.map((x) => x.toFixed(2)),
        name: 'Kilometer Point (KP)',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          fontSize: 12,
          align: 'center',
          color: 'black',
          fontFamily: 'roboto'
        }
      },
      yAxis: {
        type: 'category',
        data: props.data ? props.data?.yData?.map((y) => moment(y).format('HH:mm:ss')) : [],
        name: 'Time (hh:mm:ss)',
        nameLocation: 'middle',
        nameGap: 80,
        nameTextStyle: {
          fontSize: 12,
          align: 'center',
          color: 'black',
          fontFamily: 'roboto'
        }
      },
      dataZoom: [
        {
          type: 'inside'
        }
      ],
      visualMap: {
        min: 0,
        max: 50,
        left: 'right',
        top: 'center',
        text: ['dB', 'dB'],
        calculable: true,
        realtime: false,
        inRange: {
          color: ['#FFFFFF', '#C1E8F6', '#06A3DA', '#06A3DA', '#5731F5', '#00215F']
        }
      },
      series: [
        {
          type: 'heatmap',
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: props.data ? props.data?.data?.map((x) => [x.x, x.y, x.value]) : [],
          progressive: 5000,
          animation: false
        }
      ]
    }
  }
)
</script>

<style scoped>
.chart {
  height: 600px;
}
</style>
